export const minClearInputThresholdLenght = 2;

export const minPostalCodeValidLength = 3;
